import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { monthOptions, getYearOptions } from '../utils/helpers';
import { PaymentSlipService } from './services/payment-slip.service';
import { PaymentSlipResponseDTO } from '../interfaces/payment-slips.interface';
import { CompanyService } from '../services/company.service';
import { IComboBase } from '../interfaces/base/base.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalConfirmationComponent } from '../shared/modals/modal-confirmation/modal-confirmation.component';
import { ModalRejectComponent } from '../shared/modals/modal-reject/modal-reject.component';
import { ModalSuccessComponent } from '../shared/modals/modal-success/modal-success.component';

@Component({
  selector: 'app-payment-slips',
  templateUrl: './payment-slips.component.html',
  styleUrls: ['./payment-slips.component.scss'],
  providers: [DialogService],
})
export class PaymentSlipsComponent implements OnInit {
  dataSource: PaymentSlipResponseDTO[] = [];
  mostrar: boolean = false;
  dataToEdit: any = null;
  dataToUpdate: any = null;
  mostrarModalValidar: boolean = false;
  mostrarModalEditar: boolean = false;
  mostrarModalDetalle: boolean = false;
  dataDetail: any = null;

  isGeneratingPDF: boolean = false;

  selectedRow: any = null;
  
  // MES 
  monthOptions: IComboBase[] = [{ key: '00', text: 'Todos' }, ...monthOptions];
  currentMonth: IComboBase | null = null;
  selectedMonth: IComboBase | null = null;
  
  // AÑO
  yearOptions: IComboBase[] = [];
  selectedYear: IComboBase | null = null;
  
  isLoading: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  
  // Término de búsqueda
  searchTerm = '';
  
  userData: any = null;

  headerClasses: { [key: string]: string } = {
    '1': 'header-keola',
    '2': 'header-inresort',
    '3': 'header-inclub',
    '4': 'header-ribera',
    '5': 'header-keolafood',
    '6': 'header-valle',
  };

  currentHeaderClass: string = 'header-keola';

  selectedDocument: SafeResourceUrl | null = null;

  @Output() rowSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    private dialogService: DialogService,
    private paymentSlipService: PaymentSlipService,
    private companyService: CompanyService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    // MES actual
    this.currentMonth = this.getCurrentMonth();
    this.selectedMonth = this.currentMonth;

    // AÑO actual
    this.yearOptions = getYearOptions();
    this.selectedYear = this.yearOptions.find((y) => y.key === new Date().getFullYear().toString()) || null;
  }

  tabs: IComboBase[] = [];
  selectedTabKey: string | null = null;

  displayedColumns = [
    { key: 'paymentDocumentNumber', header: 'Nº Documento' },
    { key: 'paymentSlipAmount', header: 'Importe' },
    { key: 'period', header: 'Fecha' },
    { key: 'employeeName', header: 'Para el empleado' },
    { key: 'employeeDocumentNumber', header: 'D.N.I.' },
    { key: 'stateLastPaymentSlipName', header: 'Status' },
  ];

  actionButtons = [
    {
      icon: (row: any) =>
        row.stateLastPaymentSlipId === 4
          ? 'pi pi-verified'
          : 'pi pi-check-square',
      color: '#ED672A',
      tooltip: (row: any) =>
        row.stateLastPaymentSlipId === 4 ? 'Detalle' : 'Validar',
      action: (row: any) => {
        this.dataToUpdate = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalValidar = true;
      },
      visible: (row: any) =>
        row.isManual === 'Si' || row.stateLastPaymentSlipId == 0 ? false : true,
    },
    {
      icon: 'pi pi-pen-to-square',
      color: '#ED672A',
      tooltip: 'Editar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalEditar = true;
      },
      visible: (row: any) => (row.isManual === 'No' ? false : true),
    },
    {
      icon: 'pi pi-eye',
      color: '#ED672A',
      tooltip: 'Ver',
      action: (row: any) => {
        this.dataDetail = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalDetalle = true;
      },
      visible: (row: any) => true,
    },
    {
      icon: 'pi pi-trash',
      color: '#ED672A',
      tooltip: 'Eliminar',
      action: (row: any) => {
        this.openDeleteConfirmation(row);
      },
      visible: (row: any) => true,
    },
  ];

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.tabs = data;
        this.selectedTabKey = this.tabs[0].key;
        this.onTabSelected(this.selectedTabKey);
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
        this.filterData();
      },
    });
  }

  openDeleteConfirmation(row: any): void {
    this.dialogService.open(ModalConfirmationComponent, {
      header: '',
      data: {
        title: 'Eliminar boleta',
        description: '¿Estás seguro de eliminar esta boleta?',
        showButton: true,
        buttonText: 'Sí, eliminar',
        buttonAction: () => {
          this.deletePaymentSlip(row.paymentSlipId);
        },
      },
    });
  }

  deletePaymentSlip(paymentSlipId: number): void {
    this.isLoading = true;

    this.paymentSlipService.deletePaymentSlip(paymentSlipId).subscribe({
      next: (res) => {
        this.isLoading = false;

        this.clearPreview();
        this.filterData();

        this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text:
              res?.message ||
              res?.success ||
              'Boleta eliminada correctamente.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      },
      error: (err) => {
        this.isLoading = false;

        this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text:
              err.error?.error ||
              err.error?.message ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      },
    });
  }

  onNewRegister(): void {
    this.mostrar = true;
  }

  onBulkLoad(): void {
    this.router.navigate(['/dashboard/payment-slips/bulk-load']);
  }

  onDialogClose() {
    this.mostrar = false; // Cierra el modal
  }

  onDialogDetailClose() {
    this.mostrarModalDetalle = false;
    this.mostrarModalValidar = false;
    this.dataDetail = null;
  }

  onMonthChange(selected: IComboBase): void {
    this.selectedMonth = selected;
    this.filterData(true); // Aplicar filtro cuando cambia el mes
  }

  onYearChange(selected: IComboBase): void {
    this.selectedYear = selected;
    this.filterData(true);
  }

  private clearPreview(): void {
    this.selectedRow = null;
    this.selectedDocument = null;
    this.isGeneratingPDF = false;
    this.cdr.detectChanges();
  }

  private getCurrentMonth(): IComboBase | null {
    const currentMonthKey = new Date().toLocaleDateString('en-GB', {
      month: '2-digit',
    });
    return (
      this.monthOptions.find((option) => option.key === currentMonthKey) || null
    );
  }

  onSearch(query: string): void {
    this.searchTerm = query;
    this.filterData(true); // Aplicar filtro cuando cambia la búsqueda
  }

  filterData(resetPage: boolean = false): void {
    if (resetPage) {
      this.pageIndex = 0;
    }

    this.clearPreview();
    this.isLoading = true;
    const filters = {
      search: this.searchTerm || null,
      month: this.selectedMonth?.key == '00' ? null : this.selectedMonth?.key, // Si no hay mes seleccionado, enviar null
      year: this.selectedYear?.key || null,
      companyId: this.selectedTabKey || null,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.paymentSlipService.getAllPaymentSlips(filters).subscribe({
      next: (response) => {
        this.dataSource = response.content;
        this.pageIndex = response.page.page;
        this.pageSize = response.page.size;
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onTabSelected(tabKey: string): void {
    this.selectedTabKey = tabKey;
    this.currentHeaderClass = this.headerClasses[tabKey] || 'header-keola';
    this.selectedDocument = null;
    this.filterData(true);
    // Puedes agregar lógica adicional aquí, como actualizar los datos mostrados
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }

  generatePDF() {
    if (this.selectedRow && this.selectedRow.paymentSlipId) {
      const paymentSlipId = this.selectedRow.paymentSlipId;
      this.isGeneratingPDF = true;

      this.paymentSlipService
        .getGeneratePDF(paymentSlipId, this.userData.employeeId)
        .subscribe({
          next: (response) => {
            this.filterData();

            setTimeout(() => {
              const updatedRow = this.dataSource.find(
                (row) => row.paymentSlipId === paymentSlipId
              );

              if (updatedRow) {
                this.selectedRow = updatedRow;

                this.onRowSelected(updatedRow);
                this.rowSelected.emit(updatedRow);

                setTimeout(() => {
                  this.selectedDocument = null;

                  setTimeout(() => {
                    this.selectedDocument =
                      this.sanitizer.bypassSecurityTrustResourceUrl(
                        this.selectedRow.paymentSlipUrl
                      );

                    this.isGeneratingPDF = false;

                    this.cdr.detectChanges();
                  }, 100);
                }, 0);
              } else {
                console.warn(
                  'No se encontró la fila actualizada en dataSource'
                );
              }
            }, 1000);
          },
          error: (error) => {
            console.error('Error generando boleta:', error);
            this.isGeneratingPDF = false;
          },
        });
    } else {
      console.warn('No hay fila seleccionada o no tiene paymentSlipId');
    }
  }

  updateSelectedDocument(url: string) {
    this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.cdr.detectChanges();
  }

  // Método para manejar la selección de la fila
  onRowSelected(row: any): void {
    this.selectedRow = row;

    if (row && row.paymentSlipUrl) {
      const uniqueUrl = `${
        row.paymentSlipUrl
      }?timestamp=${new Date().getTime()}`;
      this.selectedDocument =
        this.sanitizer.bypassSecurityTrustResourceUrl(uniqueUrl);
    } else {
      this.selectedDocument = null;
    }
    this.cdr.detectChanges();
  }

  onRegisterComplete(): void {
    this.filterData();
  }

  onUpdateStateComplete(): void {
    this.filterData();
  }

  onEditComplete(): void {
    this.filterData();
  }

  onDeleteComplete(): void {
    this.filterData();
  }
}
